import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConnectEventStreamingService } from '../../core/connect-event-streaming.service';
import { MessageService } from '../../core/message.service';
import { ActionType } from 'app/connect/core/kafka.enum';

@Component({
  selector: 'biz-connect-event-streaming-detail',
  templateUrl: './connect-event-streaming-detail.component.html',
  styleUrls: ['./connect-event-streaming-detail.component.scss']
})
export class ConnectEventStreamingDetailComponent implements OnInit {

  @Input() kafkaConfiguration: IKafkaConfiguration;
  @Output() onSave = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onLoadingChange = new EventEmitter<boolean>(); // NUEVO: Emitir estado de loading al padre

  isTestingConnection: boolean = false;
  connectionTestResult: IEventStreamingTestResponse;
  
  private originalConfiguration: string;

  // Dropdown options
  securityProtocolOptions = [
    { value: 'PLAINTEXT', label: 'PLAINTEXT' },    
    { value: 'SASLSSL', label: 'SASL_SSL (Usuario/Contraseña + SSL)' },
    { value: 'SASLPLAINTEXT', label: 'SASL_PLAINTEXT' }
  ];

  actionTypeOptions = [
    { value: ActionType.NewRecordEntity, label: 'EVENT_STREAMING.ACTION_NEW_RECORD_ENTITY' },
    { value: ActionType.CreateCase, label: 'EVENT_STREAMING.ACTION_CREATE_CASE' }
  ];

  constructor(
    private _eventStreamingService: ConnectEventStreamingService,
    private _translateService: TranslateService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.originalConfiguration = JSON.stringify(this.kafkaConfiguration);
  }

  updateOriginalConfiguration(kafkaConfiguration: IKafkaConfiguration) {
    this.originalConfiguration = JSON.stringify(kafkaConfiguration);
  }

  areThereAnyPendingChanges(): boolean {
    return this.originalConfiguration !== JSON.stringify(this.kafkaConfiguration);
  }

  async testConnection() {
    // Activar loading en el componente padre
    this.onLoadingChange.emit(true);
    this.isTestingConnection = true;
    this.connectionTestResult = null;
    
    try {
      const connection = this.kafkaConfiguration.environment.connection;
      this.connectionTestResult = await this._eventStreamingService.testEventStreamConnection(connection);
      
      if (this.connectionTestResult.Success) {
        this._translateService.get('EVENT_STREAMING.CONNECTION_SUCCESS').subscribe((message: string) => {
          this.messageService.showSuccess(message);
        });
      } else {
        this.messageService.showError(this.connectionTestResult.ErrorMessage || 
          this._translateService.instant('EVENT_STREAMING.CONNECTION_FAILED'));
      }
    } catch (error) {
      this._translateService.get('EVENT_STREAMING.CONNECTION_FAILED').subscribe((message: string) => {
        this.messageService.showError(message);
      });
    } finally {
      // Desactivar loading en el componente padre
      this.isTestingConnection = false;
      this.onLoadingChange.emit(false);
    }
  }

  removeInboundSetting(index: number) {
    this.kafkaConfiguration.environment.inboundSettings.splice(index, 1);
  }

  toggleInboundSetting(setting: IKafkaInboundSetting) {
    setting.overridableSettings.enabled = !setting.overridableSettings.enabled;
  }

  getActionTypeLabel(actionType: ActionType): string {
    return actionType === ActionType.NewRecordEntity ? 
      this._translateService.instant('EVENT_STREAMING.ACTION_NEW_RECORD_ENTITY') :
      this._translateService.instant('EVENT_STREAMING.ACTION_CREATE_CASE');
  }

  save() {
    // Validate required fields
    const connection = this.kafkaConfiguration.environment.connection;
    
    if (!connection.bootstrapServers) {
      this._translateService.get('EVENT_STREAMING.ERROR_BOOTSTRAP_SERVERS_REQUIRED').subscribe((message: string) => {
        this.messageService.showError(message);
      });
      return;
    }

    this.onSave.emit();
  }

  cancel() {
    this.onCancel.emit();
  }
}
